import { Avatar, ListItemAvatar, Paper, Typography } from '@mui/material'
import custom from '../../../styles/mui/szVariables.json'

export default function UserMessage({ message, ms }: any) {

  return (
    <>
      <Paper sx={{ 
          p: custom.spacing.sm, 
          ml: 10, 
          borderRadius: '16px 16px 0 16px',
          backgroundColor: 'primary.main'
        }} >
        <Typography variant='szBody.Regular.Small' 
          sx={{ color: '#FFF'}}>
          {message}
        </Typography>
      </Paper>
     <ListItemAvatar>
        <Avatar sx={{ 
                position: 'absolute', 
                right:'35px', 
                bottom: '0px', 
                height: '30px',
                width: '30px'
            }} alt="User" 
            src="/images/user.jpg" />
      </ListItemAvatar>
    </>   
  )
}
